import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../../styles/WhatsAppPermissionDenied.scss';

/**
 * Component shown when user doesn't have WhatsApp permissions
 */
const WhatsAppPermissionDenied = () => {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.auth.user);

  const handleGoBack = () => {
    if (role === 'manager' || role === 'admin') {
      navigate('/manager/dashboard');
    } else {
      navigate('/dashboard');
    }
  };

  const getMessage = () => {
    switch (role) {
      case 'manager':
      case 'admin':
        return {
          title: 'WhatsApp Access Restricted',
          description: 'Your account type does not have access to WhatsApp features. Please contact your administrator for access.',
          actionText: 'Return to Dashboard'
        };
      default:
        return {
          title: 'WhatsApp Not Available',
          description: 'WhatsApp features are not available for your account type. Please upgrade your plan or contact support.',
          actionText: 'Return to Dashboard'
        };
    }
  };

  const { title, description, actionText } = getMessage();

  return (
    <div className="whatsapp-permission-denied-container">
      <div className="permission-denied-content">
        <div className="error-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z" fill="#ff6b6b"/>
          </svg>
        </div>
        <h2>{title}</h2>
        <p>{description}</p>
        <button
          className="btn btn-primary"
          onClick={handleGoBack}
        >
          {actionText}
        </button>
      </div>
    </div>
  );
};

export default WhatsAppPermissionDenied;